"use client";
import { Box, Card, CardActionArea, Divider, Icon, InputAdornment, Skeleton, Stack, TextField, Typography } from "@mui/material";
import SearchNormalIcon from "@/app/_components/Icons/SearchNormalIcon";
import React, { useState } from "react";
import { useDebounce } from "use-debounce";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useGqlClient } from "@/Providers/GQLProvider";
import NextLink from "next/link";
import Image from "next/image";

export default function SearchContentLoading() {
  return (
    <>
      <Box sx={{ p: 1 }}>
        <Stack spacing={2}>
          <Stack spacing={1}>
            {Array.from({ length: 3 }).map((_, i) => {
              return (
                <Card sx={{ borderRadius: 2 }} elevation={0} key={i}>
                  <Stack spacing={1} direction={"row"}>
                    <Card
                      elevation={0}
                      variant={"outlined"}
                      sx={{
                        borderRadius: 3,
                        width: 45,
                        minWidth: 45,
                        maxHeight: 45,
                        aspectRatio: 1,
                        position: "relative",
                      }}
                    >
                      <Skeleton width="100%" height="100%" variant={"rounded"} animation={"wave"} />
                    </Card>
                    <Stack
                      width={"100%"}
                      sx={{
                        overflow: "hidden", // Ensures content doesn't overflow the stack
                        textOverflow: "ellipsis", // Adds ellipsis where applicable
                        whiteSpace: "nowrap", // Prevents wrapping within the stack
                      }}
                    >
                      <Typography
                        variant={"subtitle2"}
                        noWrap
                        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      >
                        <Skeleton width="100%" height="5" variant={"text"} animation={"wave"} />
                      </Typography>
                      <Typography variant={"body2"} className={""} sx={{ color: "grey.500" }}>
                        <Skeleton width="50%" height="5" variant={"text"} animation={"wave"} />
                      </Typography>
                    </Stack>
                  </Stack>
                </Card>
              );
            })}
          </Stack>
          <Divider sx={{ borderBottomColor: "grey.100" }} />
          <Stack spacing={1}>
            {Array.from({ length: 2 }).map((_, i) => {
              return (
                <Card sx={{ borderRadius: 2 }} elevation={0} key={i}>
                  <Stack spacing={1} direction={"row"}>
                    <Stack
                      width={"100%"}
                      spacing={0.5}
                      sx={{
                        overflow: "hidden", // Ensures content doesn't overflow the stack
                        textOverflow: "ellipsis", // Adds ellipsis where applicable
                        whiteSpace: "nowrap", // Prevents wrapping within the stack
                      }}
                    >
                      <Typography
                        variant={"body2"}
                        noWrap
                        sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "flex", gap: 1 }}
                      >
                        <Icon fontSize={"small"}>
                          <SearchNormalIcon />
                        </Icon>
                        <Skeleton width="40%" height="5" variant={"text"} animation={"wave"} />
                      </Typography>
                      <Typography variant={"body2"} className={""} sx={{ color: "grey.700" }}>
                        <Skeleton width="60%" height="5" variant={"text"} animation={"wave"} />
                      </Typography>
                    </Stack>
                  </Stack>
                </Card>
              );
            })}
          </Stack>
        </Stack>
      </Box>
    </>
  );
}
